(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["key-points-list"] && !Shopify.designMode) return;
  try {
    
  class KeyPointsList extends HTMLElement {
    constructor() {
      super();
      this.listeners = new AbortController();
    }

    /**
     * Sets the position of the content to be the level with the label.
     *
     * @param {HTMLElement} $label - The label element.
     * @param {HTMLElement} $content - The content element.
     */
    setContentPositionTop($label, $content) {
      const labelPositionTop = $label.offsetTop;
      $content.style.cssText += `--label-position-top: ${labelPositionTop}px;`;
    }

    /**
     * Sets the event listeners for the label and content elements.
     *
     * @param {HTMLElement} $label - The label element.
     * @param {HTMLElement} $content - The content element.
     */
    setEventListeners($label, $content) {
      const setItemActive = () => {
        $label.classList.add('key-points-list__label--active');
        $content.classList.add('key-points-list__content--active');
      };

      const setItemInactive = () => {
        $label.classList.remove('key-points-list__label--active');
        $content.classList.remove('key-points-list__content--active');
      };

      $label.addEventListener('mouseenter', setItemActive, { signal: this.listeners.signal });
      $label.addEventListener('mouseleave', setItemInactive, { signal: this.listeners.signal });
      $label.addEventListener('focus', setItemActive, { signal: this.listeners.signal });
      $label.addEventListener('blur', setItemInactive, { signal: this.listeners.signal });
    }

    connectedCallback() {
      // Remove from layout flow, preserve children
      this.style.display = 'contents';

      const $list = this.querySelector('.key-points-list__list');
      const $labels = $list.querySelectorAll('.key-points-list__label');

      $labels.forEach(($label) => {
        const labelId = $label.dataset.labelId;
        const $content = $list.querySelector(`[data-content-id="${labelId}"]`);
        if (!$content) return;

        this.setContentPositionTop($label, $content);
        this.setEventListeners($label, $content);
      });
    }

    disconnectedCallback() {
      this.listeners.abort();
    }
  }

  customElements.define('key-points-list', KeyPointsList);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Handle content blocks with limits
    initContentLimits();

    // Handle collapsible content height adjustments
    initCollapsibleContent();
  });

  function initContentLimits() {
    // Select all content blocks with data-type and data-limit attributes
    document.querySelectorAll('.additional-content[data-type][data-limit]').forEach(block => {
      const type = (block.dataset.type || 'none').toLowerCase();
      const limit = parseInt(block.dataset.limit, 10) || 0;
      const container = block.querySelector('.metafield-rich_text_field');
      const seeMoreText = window.theme.strings.seeMore || 'Show More' ;
      const seeLessText = window.theme.strings.seeLess || 'Show Less' ;

      // Skip if missing required elements/attributes
      if (type === 'none' || limit <= 0 || !container || container.querySelector('.show-more-btn')) return;

      const contentElements = container.querySelectorAll('ol li, p');
      if (contentElements.length <= 0) return;

      // Check if we need a "See All" button
      let needsSeeAllButton = false;
      let originalContent = {};

      // Store original content
      contentElements.forEach((el, index) => {
        originalContent[index] = el.innerHTML;
      });

      // Determine if we need a toggle button
      if (type === 'items') {
        needsSeeAllButton = contentElements.length > limit;
      } else if (type === 'words') {
        let totalWords = 0;
        contentElements.forEach(el => {
          totalWords += el.textContent.trim().split(/\s+/).length;
        });
        needsSeeAllButton = totalWords > limit;
      }

      // If no toggle button needed, ensure all content is visible and exit
      if (!needsSeeAllButton) {
        contentElements.forEach(el => el.style.display = '');
        return;
      }

      // Set up toggle button and manage content visibility
      let isExpanded = false;

      const updateVisibility = () => {
        if (type === 'items') {
          // Show/hide based on index
          contentElements.forEach((el, index) => {
            el.style.display = isExpanded || index < limit ? '' : 'none';
          });
        } else if (type === 'words') {
          let totalWords = 0;
          let elementsToShow = 0;

          // Determine how many elements to fully show
          for (let i = 0; i < contentElements.length; i++) {
            const wordCount = contentElements[i].textContent.trim().split(/\s+/).length;
            if (totalWords + wordCount <= limit) {
              totalWords += wordCount;
              elementsToShow++;
            } else {
              break;
            }
          }

          // Apply visibility
          contentElements.forEach((el, index) => {
            if (isExpanded) {
              el.innerHTML = originalContent[index];
              el.style.display = '';
            } else if (index < elementsToShow) {
              el.innerHTML = originalContent[index];
              el.style.display = '';
            } else if (index === elementsToShow && totalWords < limit) {
              const wordsToShow = limit - totalWords;
              if (wordsToShow > 0) {
                const temp = document.createElement('div');
                temp.innerHTML = originalContent[index];
                truncateElementToWordCount(temp, wordsToShow);
                el.innerHTML = temp.innerHTML + '...';
                el.style.display = '';
              } else {
                el.style.display = 'none';
              }
            } else {
              el.style.display = 'none';
            }
          });
        }

        toggleButton.textContent = isExpanded ? seeLessText : seeMoreText;

        // Update collapsible content height if needed
        recalculateCollapsibleHeight(block);
      };

      // Create and append toggle button
      const toggleButton = document.createElement('button');
      toggleButton.textContent = seeMoreText;
      toggleButton.classList.add('show-more-btn');
      toggleButton.addEventListener('click', () => {
        isExpanded = !isExpanded;
        updateVisibility();
      });

      const buttonWrapper = document.createElement('div');
      buttonWrapper.classList.add('show-more-btn-wrapper');
      buttonWrapper.appendChild(toggleButton);
      container.appendChild(buttonWrapper);

      // Initial setup
      updateVisibility();
    });
  }

  function initCollapsibleContent() {
    // Add event listeners to collapsible triggers
    document.querySelectorAll('.collapsible-trigger').forEach(trigger => {
      trigger.addEventListener('click', function() {
        const controlsId = this.getAttribute('aria-controls');
        if (!controlsId) return;

        const collapsibleContent = document.getElementById(controlsId);
        if (!collapsibleContent) return;

        if (this.getAttribute('aria-expanded') === 'true') {
          // If expanding, wait for transition to start then adjust height
          setTimeout(() => adjustCollapsibleHeight(collapsibleContent), 50);
        }
      });
    });
  }

  function truncateElementToWordCount(element, wordCount) {
    let currentCount = 0;

    for (let i = 0; i < element.childNodes.length && currentCount < wordCount; i++) {
      const node = element.childNodes[i];

      if (node.nodeType === Node.TEXT_NODE) {
        const words = node.textContent.trim().split(/\s+/);
        const remainingWords = wordCount - currentCount;

        if (words.length > remainingWords) {
          node.textContent = words.slice(0, remainingWords).join(' ');
          currentCount += remainingWords;

          // Remove following nodes
          while (element.childNodes[i + 1]) {
            element.removeChild(element.childNodes[i + 1]);
          }
        } else {
          currentCount += words.length;
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        truncateElementToWordCount(node, wordCount - currentCount);
        const wordsInElement = node.textContent.trim().split(/\s+/).length;
        currentCount += wordsInElement;

        if (currentCount >= wordCount) {
          while (element.childNodes[i + 1]) {
            element.removeChild(element.childNodes[i + 1]);
          }
        }
      }
    }
  }

  function findClosestCollapsibleContent(element) {
    let current = element;
    while (current) {
      if (current.classList && current.classList.contains('collapsible-content')) {
        return current;
      }
      current = current.parentElement;
    }
    return null;
  }

  function recalculateCollapsibleHeight(element) {
    const collapsibleContent = findClosestCollapsibleContent(element);

    if (collapsibleContent && collapsibleContent.classList.contains('is-open')) {
      const innerContent = collapsibleContent.querySelector('.collapsible-content--inner') ||
        collapsibleContent.querySelector('.collapsible-content__inner');

      if (innerContent) {
        setTimeout(() => {
          const contentHeight = innerContent.scrollHeight;
          collapsibleContent.style.height = contentHeight + 'px';

          // Handle carousel resize if needed
          const carousel = innerContent.querySelector('.flickity-enabled');
          if (carousel && window.Flickity) {
            const flkty = Flickity.data(carousel);
            if (flkty) {
              setTimeout(() => flkty.resize(), 100);
            }
          }
        }, 50);
      }
    }
  }

  function adjustCollapsibleHeight(collapsibleEl) {
    const innerContent = collapsibleEl.querySelector('.collapsible-content--inner') || collapsibleEl.querySelector('.collapsible-content__inner');

    if (!innerContent) return;

    // Handle carousels
    innerContent.querySelectorAll('.flickity-enabled').forEach(carousel => {
      if (window.Flickity) {
        const flkty = Flickity.data(carousel);
        if (flkty) {
          setTimeout(() => flkty.resize(), 100);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["richtext-tabs"] && !Shopify.designMode) return;
  try {
    
  class IngredientsTab extends HTMLElement {

    constructor() {
      super();
      this.controller = new AbortController();

      // Configuration
      this.c = {
        dom: {
          content: '.js-richtext-tabs-ingredients'
        }
      };
    }

    /**
     * @param {Event} event - Custom 'variantsIngredientsChange' event.
     */
    handleIngredientsUpdate(event) {
      const $ingredientsContents = this.querySelectorAll(this.c.dom.content);
      if (!$ingredientsContents.length) {
        return;
      }

      $ingredientsContents.forEach(($ingredientsContent) => {
        $ingredientsContent.innerHTML = event.detail;
      });
    }

    connectedCallback() {
      // Remove from layout flow, preserve children
      this.style.display = 'contents';

      window.addEventListener(
        'variantIngredientsChange',
        (event) => this.handleIngredientsUpdate(event),
        { signal: this.controller.signal }
      );
    }

    disconnectedCallback() {
      this.controller.abort();
    }
  }

  customElements.define('ingredients-tab', IngredientsTab);

  } catch(e) { console.error(e); }
})();
})();
